export default __webpack_public_path__ + "static/media/collart.97b4dc28.svg";